import React from 'react'
import { Button, Flex, Text } from '../../vanilla'
import { useOrderStore, useBasketStore } from '../../store/hooks/useStore'
import { ORDER_UI_STATUS } from '../../utils/constants'
import { OrderUIStatus } from '../../types/store/order'
import useNavigation from '../../hooks/use-navigation'
import { useTimer } from '../../hooks/use-timer'
import { ShopperCustomers } from 'commerce-api'
import { DeliveryTimeAndDate } from './delivery-time-and-date'

interface DeliveryOrderInfoProps {
    order: ShopperCustomers.Order
    isMiniBasket?: boolean
    isPopover?: boolean
    onBookNewDelivery?: () => void
    onCheckOrder?: () => void
}

export const DeliveryOrderInfo = ({
  order,
  isMiniBasket = false,
  isPopover = false,
  onBookNewDelivery,
  onCheckOrder
}: DeliveryOrderInfoProps) => {
    const {getOrderEditAvailabilityExpiryTimeISO, getOrderStatus, handleOrderEditAvailability} = useOrderStore()
    const {slotTime} = useBasketStore()
    const deliveryStatus = getOrderStatus(order) as OrderUIStatus
    const navigate = useNavigation()

    const editExpiryTime = deliveryStatus === ORDER_UI_STATUS.PLACED
        ? getOrderEditAvailabilityExpiryTimeISO(order) ?? undefined
        : undefined

    const editAvailable = handleOrderEditAvailability(order)

    const ExpiryCountDown = ({expiryTime}: {expiryTime: string}) => {
        const {minutes, hours} = useTimer(expiryTime || '', true)
        return (
            <Text as="span" variant="text4" color="accent0" data-test-selector="edit-order-expiry-countdown">
                {`${hours}h:${minutes}m`}
            </Text>
        )
    }

    return (
      <>
        <Text variant="text4" flexGrow="1">
          <Text variant="text4" color="accent0">
            {isMiniBasket
              ? "Your order's scheduled for delivery:"
              : "We'll deliver your order between:"}
          </Text>
          <DeliveryTimeAndDate
            startHour={slotTime(order.c_windowStartTime)}
            endHour={slotTime(order.c_windowEndTime)}
            textProps={{variant: 'text4', flexGrow: '1'}}
            showDate={true}
            windowStartTime={order.c_windowStartTime}
            windowEndTime={order.c_windowEndTime}
          />
        </Text>
        {editAvailable && editExpiryTime && (
          <Text variant="text4" data-test-selector="edit-order-expiry-text">
            {!isMiniBasket && (
              <>
                Have you got everything you need? <br />
              </>
            )}
            You've got {<ExpiryCountDown expiryTime={editExpiryTime} />} to
            update your order!
          </Text>
        )}
        <Flex gap="8px" width={isPopover || isMiniBasket ? 'full' : 'auto'}>
          <Button
            variant={isMiniBasket ? 'secondary' : 'primary'}
            size="sm"
            width="full"
            flexBasis={['full', 'auto']}
            onClick={() => {
              onCheckOrder?.()
              navigate('/account/order-history')
            }}
            data-test-selector="check-order-button"
          >
            Check Order
          </Button>
          {(isPopover || isMiniBasket) && (
            <Button
              variant='outlineDark'
              size="sm"
              width="full"
              flexBasis={['full', 'auto']}
              onClick={() => {
                onBookNewDelivery?.()
                navigate('/select-delivery')
              }}
              data-test-selector="book-new-delivery-button"
            >
              Book new delivery
            </Button>
          )}
        </Flex>
      </>
    )
}